import {Component, Input, OnInit, ViewChild} from '@angular/core';
import { CommonModule } from '@angular/common';
import {MatSort} from "@angular/material/sort";
import {MatPaginator} from "@angular/material/paginator";
import {MatTableDataSource} from "@angular/material/table";
import { MaterialModule } from "src/app/app.materials";
import { PopoverComponent } from "../../popover/popover.component";

@Component({
  selector: 'app-custom-portfolio-section',
  templateUrl: './custom-portfolio-section.component.html',
  standalone: true,
  imports: [CommonModule, MaterialModule, PopoverComponent]
})
export class CustomPortfolioSectionComponent implements OnInit {

  @Input() params: any = {};

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  companies = [];

  dataSource = new MatTableDataSource<any>(this.companies);
  displayedColumns: string[] = ['company_name', 'region_name', 'sector_name', 'market_name', 'market_cap'];

  constructor() { }

  ngOnInit(): void {
    this.params.region = this.params.regions.map(r => r.name);
    this.params.region = this.params.region.join(', ');

    this.params.market = this.params.markets.map(r => r.name);
    this.params.market = this.params.market.join(', ');

    this.params.sector = this.params.sectors.map(r => r.name);
    this.params.sector = this.params.sector.join(', ');

    if (this.params.excluded) {
      this.companies = this.params.excluded;
      this.dataSource.data = this.companies;
    }

  }

  closeOtherCompanies(company) {
    this.companies = this.companies.map((c: any) => {
      if (c.security_id !== company.security_id) {
        c.isOpen = false;
      }
      return c;
    });
  }
}
